var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 3.41602C3.01117 3.41602 2.75 3.67718 2.75 3.99935V13.3327C2.75 13.6548 3.01117 13.916 3.33333 13.916H12.6667C12.9888 13.916 13.25 13.6548 13.25 13.3327V3.99935C13.25 3.67718 12.9888 3.41602 12.6667 3.41602H3.33333ZM1.25 3.99935C1.25 2.84876 2.18274 1.91602 3.33333 1.91602H12.6667C13.8173 1.91602 14.75 2.84876 14.75 3.99935V13.3327C14.75 14.4833 13.8173 15.416 12.6667 15.416H3.33333C2.18274 15.416 1.25 14.4833 1.25 13.3327V3.99935Z",
    fill: "#3FB9E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0.583984C11.081 0.583984 11.4167 0.919771 11.4167 1.33398V4.00065C11.4167 4.41486 11.081 4.75065 10.6667 4.75065C10.2525 4.75065 9.91675 4.41486 9.91675 4.00065V1.33398C9.91675 0.919771 10.2525 0.583984 10.6667 0.583984Z",
    fill: "#3FB9E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33325 0.583984C5.74747 0.583984 6.08325 0.919771 6.08325 1.33398V4.00065C6.08325 4.41486 5.74747 4.75065 5.33325 4.75065C4.91904 4.75065 4.58325 4.41486 4.58325 4.00065V1.33398C4.58325 0.919771 4.91904 0.583984 5.33325 0.583984Z",
    fill: "#3FB9E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 6.66602C1.25 6.2518 1.58579 5.91602 2 5.91602H14C14.4142 5.91602 14.75 6.2518 14.75 6.66602C14.75 7.08023 14.4142 7.41602 14 7.41602H2C1.58579 7.41602 1.25 7.08023 1.25 6.66602Z",
    fill: "#3FB9E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.744e0882797e1058f67e1b0871ea8c25.svg";
export { ForwardRef as ReactComponent };